export default "__VITE_ASSET__BPlAB2iZ__"